import React, { Component } from 'react';
import { Card, CardImg, CardText, CardBlock,
  CardTitle, CardSubtitle, Button, CardLink, Row, Col } from 'reactstrap';
import Modal from 'react-modal';
import { Icon } from 'react-fa';

import './Platform.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/smartadmin-production.min.css';
import '../assets/css/smartadmin-production-plugins.min.css';

class Platform extends Component {
	state = { profileModal: false }

  toggleModal() {
    this.setState({ profileModal: !this.state.profileModal });
    this.props.onModalToggle();
  }

  render() {
    return (
      <Card className="platform">
        <CardTitle className="company-subtitle">
            <span>{this.props.companySubtitle}</span>
        </CardTitle>
        <div className="company-logo">
          <img width="100%" src={this.props.logo} alt="Card image cap" />
        </div>

        <Row className="ratings">
          <Col xs="6">
                {this.renderRating(this.props.rating)}
          </Col>
          <Col xs="6">
                {this.renderMinInvestment(this.props.minInvestment)}
          </Col>
        </Row>
        <Row className="company-tags">
          <Col sm="2" className="company-tag">
            <Icon name="android" size="2x" className={this.props.isRobot?'':'tag-disabled'}/>
          </Col>
          <Col sm="2" className="company-tag">
            <Icon name="money" size="2x" className={this.props.isLiquid?'':'tag-disabled'}/>
          </Col>
        </Row>
        {this.renderFooter()}
      </Card>
    );
  }

  renderSummary() {
    return;
    return <CardText>{this.props.summary}</CardText>;
  }

  renderFooter() {
        return;
        return (
          <CardBlock>
          {this.renderSummary()}
          <CardLink href="#">More Details</CardLink>
          </CardBlock>
        );
  }

  renderLiquidity() {
      if (this.props.isLiquid) {
        return (
          <Col sm="3" className="company-tag">
          <div className="tag-icon">
                  <Icon name="money" size="2x"/>
                </div>
               <div className="company-tags-title">Liquid</div>
          </Col>
        );
      }

      return (
        <Col sm="3" className="company-tag">
          <div className="tag-icon">
                  <Icon name="money" size="2x"/>
                  <Icon name="times" size="2x" className="strikethrough"/>
                </div>
               <div className="company-tags-title">Illiquid</div>
        </Col>
      );
  }

  renderMinInvestment(mIS) {
      const mISL = [];
      let mISR = 0;
      
      if(mIS == 0) {
          mISR = 0;
      } else
      {
        let mISLen = String(mIS).length;
        mISR=Math.min(Math.max(1,mISLen-2),5)
      }
      for(let i = 1;i<=mISR;i++) {
        mISL.push(<Icon name="dollar"/>);
      }

      for(let i = mISR+1;i<=5;i++) {
        mISL.push(<Icon name="dollar" className="noDollar"/>);
      }
      return mISL.map(v => v)
  }

  renderRating(r) {
    const ratingS = [];
    for(let i =1 ;i <= 5; i++) {
      if (r-i >= 0) {
        ratingS.push(<Icon key={`'star_${i}`} name="star"/>) ;
      }
      else if (r-i >= -0.5) {
        ratingS.push(<Icon key={`'star_${i}`} name="star-half-o"/>) ;
      }
      else {
        ratingS.push(<Icon key={`'star_${i}`} name="star-o"/>) ;
      }
    }
    return ratingS.map(v => v);
  }
}

export { Platform };



/** WEBPACK FOOTER **
 ** ./src/common/Platform.js
 **/